import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

interface PropsQuestion {
  title: string;
  text: string;
  type: number;
}

interface IState {
  data: {
    activeQuestion: number;
    questions: PropsQuestion[];
  };
}

const initialState: IState = {
  data: {
    activeQuestion: null,
    questions: [],
  },
};

export const sezonnoeKhranenieSlice = createSlice({
  name: 'sezonnoeKhranenie',
  initialState,
  reducers: {
    setActiveQuestion: (state, action: PayloadAction<number>) => {
      state.data.activeQuestion = action.payload;
    },
    setQuestions: (state, action: PayloadAction<PropsQuestion[]>) => {
      state.data.questions = action.payload;
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.sezonnoeKhranenie,
      };
    },
  },
});

export const { setActiveQuestion, setQuestions } = sezonnoeKhranenieSlice.actions;

export const sezonnoeKhranenieReducer = sezonnoeKhranenieSlice.reducer;
